import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-24 bg-surface" data-id="element-12">
      <div className="max-w-7xl mx-auto px-6" data-id="element-13">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-14">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} data-id="element-15">
            <h2 className="text-3xl md:text-4xl font-semibold mb-6" data-id="element-16">
              Про мене
            </h2>
            <p className="text-lg text-secondary leading-relaxed mb-6 font-medium text-primary" data-id="element-17">
              Я — Марія, сертифікований бухгалтер (аудитор, IAB, IAPBE) з
              20-річним досвідом. Працюю з бізнесом будь-якого масштабу: від
              відкриття ФОП до складних проєктів з ЗЕД, виробництвом і
              міжнародними розрахунками. Вирішую нетипові задачі — ті, з якими
              не впорались інші.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-18">
            <div className="bg-background p-6 rounded-2xl border border-border flex flex-col items-center justify-center text-center hover:border-primary/30 transition-colors" data-id="element-19">
              <div className="text-2xl lg:text-3xl font-semibold text-primary mb-2" data-id="element-20">
                20+ років
              </div>
              <div className="text-sm text-secondary leading-tight font-medium" data-id="element-21">
                Практичного досвіду
              </div>
            </div>

            <div className="bg-background p-6 rounded-2xl border border-border flex flex-col items-center justify-center text-center hover:border-primary/30 transition-colors" data-id="element-22">
              <div className="text-2xl lg:text-3xl font-semibold text-primary mb-2" data-id="element-23">
                7 форм
              </div>
              <div className="text-sm text-secondary leading-tight font-medium" data-id="element-24">
                ТОВ, ФОП, ФГ, БФ, БО, ГО, ПП
              </div>
            </div>

            <div className="bg-background p-6 rounded-2xl border border-border flex flex-col items-center justify-center text-center hover:border-primary/30 transition-colors" data-id="element-25">
              <div className="text-2xl lg:text-3xl font-semibold text-primary mb-2" data-id="element-26">
                24/7
              </div>
              <div className="text-sm text-secondary leading-tight font-medium" data-id="element-27">
                Зв'язок з клієнтами
              </div>
            </div>

            <div className="bg-background p-6 rounded-2xl border border-border flex flex-col items-center justify-center text-center hover:border-primary/30 transition-colors" data-id="element-28">
              <div className="text-2xl lg:text-3xl font-semibold text-primary mb-2" data-id="element-29">
                Офіс у центрі
              </div>
              <div className="text-sm text-secondary leading-tight font-medium" data-id="element-30">
                Безкоштовне паркування
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}